import React from 'react';
import { Box, } from '@waglabs/box-next';
import styled, { keyframes, } from 'styled-components';
const loadingAnimation = keyframes `
  0% {
    background-color: #fff;
  }
  50% {
    background-color: #ccc;
  }
  100% {
    background-color: #fff;
  }
`;
export const Placeholder = (props) => (React.createElement(StyledBox, Object.assign({ bottom: 0, height: "100%", left: 0, position: "absolute", right: 0, top: 0, width: "100%" }, props)));
const StyledBox = styled(Box) `
  animation: ${loadingAnimation} 1s infinite;
`;
